//
//
//
//
//
//

import {apiUrl, apiParams} from "@/const/const";

export default {
    name: "MyFooter",
    // props: ['tel'],
    props: [],
    data() {
        return {
            tel: ''
        }
    },
    created() {
        this.getKehuTel()
    },
    methods: {
        getKehuTel() {
            // 获取“联系我们”的号码
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
            };
            this.requestApi({
                url: apiUrl.getKehuTel,
                data: data
            }, (resultData) => {
                let dataObj = resultData.data;
                this.tel = dataObj.tel || '';
            })
        },
        handleToast(e) {
            // 如果没有获取到联系方式，要提示用户刷新页面
            if (this.tel) {

            } else {
                e.preventDefault();
                this.showToast('获取不到联系方式，请刷新页面！', 1500, 'warn')
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/subComponents/MyFooter.vue